import { useEffect, useState } from 'react'
import axios from 'axios'
/** Elimina la importación de CreateNeighbor */
// import { CreateNeighbor } from './components/ModalNeig'
import { AddNeighbor } from './components/AddNeighbor'
import { EditNeighbor } from './components/EditNeighbor'
import { useAppSelector } from '../../../../redux/hooks'
import Swal from 'sweetalert2'
import { useAuth } from '../../auth'
import Spinner from '../../custom/Spinner/Spinner'
import { getCTXRlist, getCTXRlistGlobal } from '../troubleshooting/request/request'
import '../../../../app/styles/components/customSelects.css'

import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import ImportExportIcon from '@mui/icons-material/ImportExport'
import styles from './NeighborsTable.module.scss'

const API_URL = process.env.REACT_APP_API_URL

type ID = undefined | null | number

function NeighborsCrud(props: any) {
    const { currentUser } = useAuth()
    const tenant = useAppSelector((state) => state.TenantSlice.id)
    const Id = useAppSelector((state) => state.SuscriptionSlice.id)
    const Type = useAppSelector((state) => state.CloudSlice.Type)
    const ListaPermisosTenant = useAppSelector((state) => state.ListPermissionSlice.Permissions)

    const [ID, setID] = useState<ID>(undefined) // <-- Controla si abrimos modal Add (null) o Edit (número)
    const [Devices, setDevices] = useState<any | null>([])
    const [DeviceSelect, setselect] = useState<any>()
    const nameregion = useAppSelector((state) => state.RegionSlice.name)
    const FlagReg = useAppSelector((state) => state.FlagSlice.value)

    const cambiarstate = (e: any) => {
        setselect(e.target.value)
    }

    // Estados para búsqueda
    const [searchTerm, setSearchTerm] = useState('')
    const [searchColumn, setSearchColumn] = useState('All')

    // Estados para ordenamiento
    const [sortColumn, setSortColumn] = useState<string>('')
    const [sortDirection, setSortDirection] = useState<'asc' | 'desc'>('asc')

    // Estados para paginación
    const [recordsPerPage, setRecordsPerPage] = useState(10)
    const [currentPage, setCurrentPage] = useState(1)

    // Estados para datos
    const [loading, setLoading] = useState(false)
    const [Records, setRecords] = useState<any | null>([])

    function applySearch(data: any[]) {
        if (!searchTerm) return data
        const lowerTerm = searchTerm.toLowerCase()
        return data.filter((d: any) => {
            if (searchColumn === 'All') {
                return (
                    d.ipid?.toLowerCase().includes(lowerTerm) ||
                    d.local_address?.toLowerCase().includes(lowerTerm) ||
                    d.local_as?.toString().toLowerCase().includes(lowerTerm) ||
                    d.peer_as?.toString().toLowerCase().includes(lowerTerm) ||
                    d.router_id?.toLowerCase().includes(lowerTerm)
                )
            } else {
                const val = d[searchColumn]?.toString().toLowerCase() || ''
                return val.includes(lowerTerm)
            }
        })
    }
    function applySort(data: any[]) {
        if (!sortColumn) return data
        const sorted = [...data].sort((a, b) => {
            const valA = a[sortColumn]?.toString().toLowerCase() || ''
            const valB = b[sortColumn]?.toString().toLowerCase() || ''
            if (valA < valB) return sortDirection === 'asc' ? -1 : 1
            if (valA > valB) return sortDirection === 'asc' ? 1 : -1
            return 0
        })
        return sorted
    }

    const handleSort = (column: string) => {
        if (sortColumn === column) {
            setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc')
        } else {
            setSortColumn(column)
            setSortDirection('asc')
        }
    }

    const getSortIcon = (col: string) => {
        if (sortColumn === col) {
            return sortDirection === 'asc' ? (
                <KeyboardArrowUpIcon style={{ verticalAlign: 'middle' }} />
            ) : (
                <KeyboardArrowDownIcon style={{ verticalAlign: 'middle' }} />
            )
        } else {
            return <ImportExportIcon style={{ verticalAlign: 'middle', opacity: 0.7 }} />
        }
    }

    // Cargar las instancias disponibles (Devices) al montar y cuando cambien Id/Type/otros
    useEffect(() => {
        const fetchData = async () => {
            try {
                if (
                    Id &&
                    Type !== 'CloudGlobal' &&
                    currentUser?.ListPermiso?.includes('CTXR.Neighbor.List')
                ) {
                    if (tenant === 0) {
                        const ctxr = await getCTXRlist(Id, Type, nameregion)
                        if (ctxr.data && ctxr.data.error === 'id suscription invalido') {
                            setDevices([])
                        } else {
                            setDevices(ctxr.data)
                            setselect(ctxr.data[0]?.id)
                        }
                    } else if (tenant !== 0) {
                        const ctxr = await getCTXRlistGlobal(Id, tenant, Type, nameregion)
                        if (ctxr.data && ctxr.data.error === 'id suscription invalido') {
                            setDevices([])
                        } else {
                            setDevices(ctxr.data)
                            setselect(ctxr.data[0]?.id)
                        }
                    }
                } else if (
                    Id &&
                    Type === 'CloudGlobal' &&
                    currentUser?.ListPermiso?.includes('CTXR.Neighbor.List')
                ) {
                    if (tenant === 0) {
                        const ctxr = await getCTXRlist(Id)
                        if (ctxr.data && ctxr.data.error === 'id suscription invalido') {
                            setDevices([])
                        } else {
                            setDevices(ctxr.data)
                            setselect(ctxr.data[0]?.id)
                        }
                    } else if (tenant !== 0) {
                        const ctxr = await getCTXRlistGlobal(Id, tenant)
                        if (ctxr.data && ctxr.data.error === 'id suscription invalido') {
                            setDevices([])
                        } else {
                            setDevices(ctxr.data)
                            setselect(ctxr.data[0]?.id)
                        }
                    }
                }
            } catch (error) {
                console.error('Error al obtener las cuentas:', error)
            }
        }
        fetchData()
    }, [Id, nameregion, FlagReg, props.tab, currentUser, tenant, Type])

    // Cargar dispositivos si Id = -1 y se tienen permisos
    useEffect(() => {
        const fetchData = async () => {
            try {
                if (Id === -1 && currentUser?.ListPermiso?.includes('CTXR.Neighbor.List')) {
                    if (tenant === 0) {
                        const ctxr = await getCTXRlist(-1)
                        if (ctxr.data && ctxr.data.error === 'id suscription invalido') {
                            setDevices([])
                        } else {
                            setDevices(ctxr.data)
                        }
                    } else if (tenant !== 0) {
                        const ctxr = await getCTXRlistGlobal(-1, tenant)
                        if (ctxr.data && ctxr.data.error === 'id suscription invalido') {
                            setDevices([])
                        } else {
                            setDevices(ctxr.data)
                        }
                    }
                }
            } catch (error) {
                console.error('Error al obtener las cuentas:', error)
            }
        }
        fetchData()
    }, [Type, Id, props.tab, currentUser, tenant])

    useEffect(() => {
        if (Type) {
            setDevices([])
        }
    }, [Type])

    // Cada vez que cambie la instancia seleccionada, cargamos los datos automáticamente
    useEffect(() => {
        const loadNeighbors = async () => {
            if (DeviceSelect && currentUser?.ListPermiso?.includes('CTXR.Neighbor.List')) {
                try {
                    setLoading(true)
                    if (tenant !== 0) {
                        await axios
                            .get(API_URL + '/v1/ctxr/listconfigbgpneighbor/' + DeviceSelect + '?tenantId=' + tenant)
                            .then((res) => {
                                setRecords(res.data)
                                setCurrentPage(1)
                            })
                    } else {
                        await axios
                            .get(API_URL + '/v1/ctxr/listconfigbgpneighbor/' + DeviceSelect)
                            .then((res) => {
                                setRecords(res.data)
                                setCurrentPage(1)
                            })
                    }
                } catch (error: any) {
                    console.log(error)
                } finally {
                    setLoading(false)
                }
            }
        }
        loadNeighbors()
    }, [DeviceSelect, currentUser, tenant])

    useEffect(() => {
        if (DeviceSelect) {
            setRecords([])
        }
    }, [DeviceSelect])

    // Aplicamos búsqueda y ordenamiento antes de la paginación
    const filteredData = applySearch(Records || [])
    const sortedData = applySort(filteredData)

    // Paginación
    const totalItems = sortedData.length
    const totalPages = Math.ceil(totalItems / recordsPerPage)
    const startIndex = (currentPage - 1) * recordsPerPage
    const endIndex = startIndex + recordsPerPage
    const currentRecords = sortedData.slice(startIndex, endIndex)

    const handlePageChange = (page: number) => {
        if (page >= 1 && page <= totalPages) {
            setCurrentPage(page)
        }
    }

    const handleRecordsPerPageChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setRecordsPerPage(parseInt(e.target.value))
        setCurrentPage(1)
    }

    function handleSubmit(id: any) {
        Swal.fire({
            position: 'center',
            icon: 'warning',
            title: 'Are you sure?',
            text: 'Once deleted, you will not be able to recover this Neighbor!',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!',
        }).then((result) => {
            if (result.isConfirmed) {
                if (tenant === 0) {
                    axios
                        .delete(API_URL + '/v1/ctxr/deleteconfigbgpneighbor/' + DeviceSelect + '/' + id)
                        .then((res) => {
                            Swal.fire('Deleted!', 'Your Neighbor has been deleted.', 'success')
                            axios
                                .get(API_URL + '/v1/ctxr/listconfigbgpneighbor/' + DeviceSelect)
                                .then((res) => {
                                    setRecords(res.data)
                                    setCurrentPage(1)
                                })
                        })
                } else {
                    axios
                        .delete(
                            API_URL +
                            '/v1/ctxr/deleteconfigbgpneighbor/' +
                            DeviceSelect +
                            '/' +
                            id +
                            '?tenantId=' +
                            tenant
                        )
                        .then((res) => {
                            Swal.fire('Deleted!', 'Your Neighbor has been deleted.', 'success')
                            axios
                                .get(
                                    API_URL +
                                    '/v1/ctxr/listconfigbgpneighbor/' +
                                    DeviceSelect +
                                    '?tenantId=' +
                                    tenant
                                )
                                .then((res) => {
                                    setRecords(res.data)
                                    setCurrentPage(1)
                                })
                        })
                }
            } else {
                Swal.fire({ title: 'Your Neighbor is safe!', icon: 'success' })
            }
        })
    }

    return (
        <>
            {loading && <Spinner />}

            <div className="card" style={{ minHeight: '75vh' }}>
                {/* begin::Header */}
                <div
                    className="card-header border-0 pt-5"
                    style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
                >
                    <h3 className="card-title align-items-start flex-column">
                        <span className="f-titulo text-marino fs-md"></span>
                    </h3>
                    {currentUser?.ListPermiso?.includes('CTXR.Neighbor.Add') && (
                        <button onClick={() => setID(null)} className="btn-light-marino f-parrafo">
                            Add BGP Neighbor
                        </button>
                    )}
                </div>
                {/* end::Header */}

                {/* Select a CTX-R Instance */}
                <div
                    className="d-flex flex-column fw-bold fs-6 mb-4 pe-2"
                    style={{ alignItems: 'center' }}
                >
                    <label
                        className="form-label f-bold fs-p text-marino required form-label"
                        style={{ marginBottom: '10px' }}
                    >
                        Select a CTX-R Instance
                    </label>
                    <div style={{ marginBottom: '10px' }}>
                        <select
                            className="custom-select aligned-select text-center"
                            aria-label="Select example"
                            onChange={cambiarstate}
                            value={DeviceSelect}
                            style={{ minWidth: '250px' }}
                        >
                            {Devices.length === 0 && <option disabled hidden>No data</option>}
                            {Devices.map((ins: any, x: any) => (
                                <option key={x} value={ins.id}>
                                    {ins.name} ({ins.description})
                                </option>
                            ))}
                        </select>
                    </div>
                </div>

                <div className="card-body py-3">
                    <div className="tab-content">
                        <div className="tab-pane fade show active" id="kt_table_widget_5_tab_1">
                            <div className="table-responsive">
                                {/* Búsqueda y conteo */}
                                {Records && Records.length > 0 && (
                                    <div
                                        style={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                            marginBottom: '10px',
                                            marginRight: '5px',
                                        }}
                                    >
                                        <div>
                                            <span className="text-marino f-parrafo fw-semibold">
                                                Total Records: {totalItems}
                                            </span>
                                        </div>
                                        <div style={{ display: 'flex', alignItems: 'center', height: '30px' }}>
                                            <div
                                                className="input-group custom-search-group"
                                                style={{ width: '400px', display: 'flex', height: '30px' }}
                                            >
                                                <span
                                                    className="input-group-text"
                                                    style={{
                                                        justifyContent: 'center',
                                                        height: '30px',
                                                        lineHeight: '30px',
                                                        padding: '0 8px',
                                                    }}
                                                >
                                                    <i
                                                        className="bi-search"
                                                        style={{ fontSize: '1rem', color: '#FF4089', verticalAlign: 'middle' }}
                                                    ></i>
                                                </span>
                                                <select
                                                    className="form-select"
                                                    style={{
                                                        border: '1px solid var(--bs-gray-300)',
                                                        width: '130px',
                                                        height: '30px',
                                                        lineHeight: '30px',
                                                        padding: '0 8px',
                                                        fontSize: '0.875rem',
                                                    }}
                                                    value={searchColumn}
                                                    onChange={(e) => {
                                                        setSearchColumn(e.target.value)
                                                        setCurrentPage(1)
                                                    }}
                                                >
                                                    <option value="All">All</option>
                                                    <option value="ipid">Neighbor IP</option>
                                                    <option value="local_address">Local Address</option>
                                                    <option value="local_as">Local AS/Peer AS</option>
                                                    <option value="router_id">Router ID</option>
                                                </select>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    style={{
                                                        width: '200px',
                                                        height: '30px',
                                                        lineHeight: '30px',
                                                        padding: '0 8px',
                                                        fontSize: '0.875rem',
                                                    }}
                                                    placeholder={`Search by ${searchColumn === 'All' ? 'All' : searchColumn
                                                        }`}
                                                    value={searchTerm}
                                                    onChange={(e) => {
                                                        setSearchTerm(e.target.value)
                                                        setCurrentPage(1)
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {/* Tabla principal */}
                                <table
                                    className="w-full f-parrafo caption-bottom custom-table"
                                    id="table"
                                >
                                    <thead>
                                        <tr className="text-azul">
                                            <th className="table-cell" onClick={() => handleSort('ipid')}>
                                                <div className={styles['header-content']}>
                                                    <span>Neighbor IP / Description</span>
                                                    <span className={styles['sortable-column']}>
                                                        {getSortIcon('ipid')}
                                                    </span>
                                                </div>
                                            </th>
                                            <th className="table-cell" onClick={() => handleSort('local_address')}>
                                                <div className={styles['header-content']}>
                                                    <span>Local Address</span>
                                                    <span className={styles['sortable-column']}>
                                                        {getSortIcon('local_address')}
                                                    </span>
                                                </div>
                                            </th>
                                            <th
                                                className="table-cell"
                                                style={{ cursor: 'pointer' }}
                                                onClick={() => handleSort('local_as')}
                                            >
                                                <div className={styles['header-content']}>
                                                <span>Local/Peer AS</span>
                                                <span className={styles['sortable-column']}>
                                                    {getSortIcon('local_as')}
                                                </span>
                                                </div>
                                            </th>
                                            <th className="table-cell" onClick={() => handleSort('router_id')}>
                                                <div className={styles['header-content']}>
                                                    <span>Router ID</span>
                                                    <span className={styles['sortable-column']}>
                                                        {getSortIcon('router_id')}
                                                    </span>
                                                </div>
                                            </th>
                                            <th className="table-cell" style={{ width: '200px' }}>
                                                Actions
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {currentRecords.length === 0 ? (
                                            <tr>
                                                <td
                                                    colSpan={6}
                                                    style={{ textAlign: 'center', color: 'gray', padding: '20px' }}
                                                >
                                                    No Data Available
                                                </td>
                                            </tr>
                                        ) : (
                                            currentRecords.map((d: any, i: any) => (
                                                <tr key={i} className="table-row">
                                                    <td className="table-cell">
                                                        <div>
                                                            <span>{d.ipid}</span>
                                                            {d.description && (
                                                                <>
                                                                    {' '} /<br />
                                                                    <span style={{ color: '#777', fontSize: '0.85em' }}>
                                                                        {d.description}
                                                                    </span>
                                                                </>
                                                            )}
                                                        </div>
                                                    </td>
                                                    <td className="table-cell">{d.local_address}</td>
                                                    <td className="table-cell">
                                                    {d.local_as} / {d.peer_as}
                                                    </td>
                                                    <td className="table-cell">{d.router_id}</td>

                                                    <td
                                                        className="table-cell"
                                                        style={{ display: 'flex', justifyContent: 'center', width: '200px' }}
                                                    >
                                                        <div style={{ display: 'flex', gap: '10px' }}>
                                                            {currentUser?.ListPermiso?.includes('CTXR.Neighbor.Update') && (
                                                                <button
                                                                    className="btn btn-marino f-parrafo"
                                                                    onClick={() => setID(d.id)} // <-- Asignamos ID = d.id => Edit
                                                                >
                                                                    Edit
                                                                </button>
                                                            )}
                                                            {currentUser?.ListPermiso?.includes('CTXR.Neighbor.Delete') && (
                                                                <button
                                                                    className="btn btn-danger f-parrafo"
                                                                    onClick={() => handleSubmit(d.id)}
                                                                    data-kt-users-table-filter="delete_row"
                                                                >
                                                                    Delete
                                                                </button>
                                                            )}
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))
                                        )}
                                    </tbody>
                                </table>
                            </div>
                            <br />

                            {filteredData.length > 0 && (
                                <div
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        marginTop: '10px',
                                    }}
                                >
                                    <div>
                                        {currentPage > 1 && (
                                            <button
                                                onClick={() => handlePageChange(currentPage - 1)}
                                                className="btn btn-secondary"
                                            >
                                                Previous
                                            </button>
                                        )}
                                    </div>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                        <span>
                                            Page {currentPage} of {totalPages}
                                        </span>
                                    </div>
                                    <div style={{ display: 'flex', gap: '10px' }}>
                                        {currentPage < totalPages && (
                                            <button
                                                onClick={() => handlePageChange(currentPage + 1)}
                                                className="btn btn-secondary"
                                            >
                                                Next
                                            </button>
                                        )}
                                        <div className="select-container" style={{ width: '120px' }}>
                                            <select
                                                className="custom-select aligned-select text-center"
                                                aria-label="Select items per page"
                                                value={recordsPerPage}
                                                onChange={handleRecordsPerPageChange}
                                                style={{
                                                    height: '30px',
                                                    lineHeight: '30px',
                                                    padding: '0 8px',
                                                    fontSize: '0.875rem',
                                                }}
                                            >
                                                <option value={5}>5 rows</option>
                                                <option value={10}>10 rows</option>
                                                <option value={20}>20 rows</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            {/* MOSTRAR MODALES SEGÚN EL VALOR DE ID */}
            {ID !== undefined && (
                // Si ID === null => AddNeighbor
                ID === null ? (
                    <AddNeighbor
                        setID={setID}
                        id={ID}
                        Dev={Devices}
                        uuid={DeviceSelect}
                        setRecords={setRecords}
                        device={setselect}
                        // Pasamos el nombre/descr de la instancia preseleccionada
                        instanceName={
                            Devices.find((ins: any) => ins.id === DeviceSelect)
                                ? Devices.find((ins: any) => ins.id === DeviceSelect).name +
                                ' (' +
                                Devices.find((ins: any) => ins.id === DeviceSelect).description +
                                ')'
                                : ''
                        }
                    />
                ) : (
                    // Si ID !== null => EditNeighbor
                    <EditNeighbor
                        setID={setID}
                        id={ID}
                        Dev={Devices}
                        uuid={DeviceSelect}
                        setRecords={setRecords}
                        device={setselect}
                    />
                )
            )}

            <br />
        </>
    )
}

export default NeighborsCrud
